import Etiquette from './Etiquette.view';

export default Etiquette;
